import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CircularProgress, Box, Typography } from '@mui/material';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Supabaseが自動的にセッションを処理
    // 認証後、ダッシュボードにリダイレクト
    const timer = setTimeout(() => {
      navigate('/');
    }, 1500);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      justifyContent="center" 
      alignItems="center" 
      minHeight="100vh"
    >
      <CircularProgress size={60} />
      <Typography variant="h6" sx={{ mt: 3 }}>
        認証中...
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
        しばらくお待ちください
      </Typography>
    </Box>
  );
};

export default AuthCallback;